<template>
	<div class="MultipleTopVisibilityBannersWrapper" :class="cssClass">
		<AdBanner
			v-for="(id, index) in bannerIds"
			:key="id"
			:containerId="id"
			:bannerType="bannerType"
			:cssClass="cssClass"
			:clusterIndex="index"
		/>
	</div>
</template>

<script setup lang="ts">
import AdBanner from './AdBanner.vue';
import type { BannerType } from '../types/google-tag.types';

defineProps<{
	bannerIds: string[];
	bannerType: BannerType;
	cssClass: string;
}>();
</script>
